import { render, staticRenderFns } from "./merchantSuYuan.vue?vue&type=template&id=80e1ce6c&scoped=true"
import script from "./merchantSuYuan.vue?vue&type=script&lang=js"
export * from "./merchantSuYuan.vue?vue&type=script&lang=js"
import style0 from "./merchantSuYuan.vue?vue&type=style&index=0&id=80e1ce6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e1ce6c",
  null
  
)

export default component.exports